import React, { useState, useEffect, useMemo, useRef } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { useDropzone } from "react-dropzone";
// import "./Atest.css";
import { InfinitySpin } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { getData, putData } from "../../FetchNodeServices";
import { useSelector } from "react-redux";
import Select from "react-select";
import { ChromePicker } from "react-color";
import AlertMessages from "../Mains/Alerts";

const Branding = () => {
  const [isActivated, setActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState();
  // const [isVisible, setIsVisible] = useState(false);
  const [customerBranding, setCustomerBranding] = useState("");
  const [surveyDomain, setSurveyDomain] = useState("");
  const [surveyDomainError, setSurveyDomainError] = useState("");
  const [isDataChanged, setDataChanged] = useState(false);
  const [HelpdeskEmail, setHelpdeskEmail] = useState("");
  const [HelpdeskEmailError, setHelpdeskEmailError] = useState("");
  const [termslink, setTermsLink] = useState("");
  const [privacyLink, setPrivacyLink] = useState("");
  const [primaryColor, setPrimaryColor] = useState("#FFFFFF");
  const [secondaryColor, setSecondaryColor] = useState("#FFFFFF");
  const [showPrimaryColorPicker, setShowPrimaryColorPicker] = useState(false);
  const [showSecondaryColorPicker, setShowSecondaryColorPicker] = useState(false);
  const [primaryTypeface, setPrimaryTypeface] = useState(null);
  const [primaryTypefaceList, setPrimaryTypefaceList] = useState([]);
  const [image, setImage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);

  const customer = useSelector((state) => state.user.users[0]);
  const user = useMemo(() => customer?.userId || "", [customer]);
  const account = useMemo(() => customer?.accountId || "", [customer]);
  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;

  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  let navigate = useNavigate();

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target) && pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowSecondaryColorPicker(false);
      setShowPrimaryColorPicker(false);
    }
  };

  useEffect(() => {
    fetchCustomerAdmins();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  // const toggleVisibility = (event) => {
  //   const value = event.target.value;
  //   setIsVisible(value === "1");
  //   setCustomerBranding(value);
  //   setDataChanged(true);
  // };

  // const handleInputFocus = () => {
  //   setShowSecondaryColorPicker(true);
  // };

  useEffect(() => {
    const fetchGoogleFonts = async () => {
      try {
        const response = await fetch("https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyCsDW2J6_A5rmQskjYEFdHyyNeY8-lUaHQ");
        if (response.ok) {
          const data = await response.json();
          if (data.items) {
            const fonts = data.items.map((font) => ({
              value: font.family,
              label: font.family,
            }));
            setPrimaryTypefaceList(fonts);
          }
        } else {
          throw new Error("Failed to fetch Google Fonts");
        }
      } catch (error) {
        console.error("Error fetching Google Fonts:", error);
        setAlerts([{ variant: "danger", heading: "Error fetching Google Fonts:." }]);
      }
    };

    fetchGoogleFonts();
  }, []);

  const fetchCustomerAdmins = async () => {
    let result = await getData(`users/branding-details/${user}/${account}`);
    if (result) {
      setCustomerBranding(result.customerBranding);
      setSurveyDomain(result.surveyDomain);
      setHelpdeskEmail(result.helpDeskEmail);
      setTermsLink(result.termAndConditionLink);
      setPrivacyLink(result.privacyLink);
      setPrimaryColor(result.primaryColorCode);
      setSecondaryColor(result.secondaryColorCode);
      setPrimaryTypeface(result.surveyFont);
      setImage(result.logo);
      setIsLoading(false);
      // setIsVisible(result.customerBranding);
    }
  };

  const isValidDomain = (domain) => {
    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
    return domainRegex.test(domain);
  };

  // const handleInputChange = (event, setter) => {
  //   const { value } = event.target;
  //   if (setter === setSurveyDomain) {
  //     if (isValidDomain(value)) {
  //       setSurveyDomainError("");
  //     } else {
  //       setSurveyDomainError("Please enter a valid domain.");
  //     }
  //   }
  //   setter(value);
  //   setDataChanged(true);
  // };
  // const handleInputChange = (event, setter, errorSetter) => {
  //   const { value } = event.target;
  //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  //   if (setter === setHelpdeskEmail) {
  //     if (!emailRegex.test(value)) {
  //       errorSetter("Please enter a valid email address.");
  //     } else if (
  //       value.split("@")[1].includes(".") &&
  //       value.split("@")[1].split(".").length > 2
  //     ) {
  //       errorSetter(
  //         "Email should not contain multiple periods after the domain."
  //       );
  //     } else {
  //       errorSetter(null); // Clear any previous errors
  //     }
  //   }

  //   setter(value); // Update state with input value
  //   setDataChanged(true); // Mark data as changed
  // };

  const handleInputChange = (event, setter, errorSetter) => {
    const { value } = event.target;

    // Strict email validation regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (setter === setHelpdeskEmail) {
      if (!emailRegex.test(value)) {
        errorSetter("Please enter a valid email address.");


      } else {
        const [localPart, domainPart] = value.split("@");
        const domainParts = domainPart.split(".");

        if (
          localPart.startsWith(".") ||
          localPart.endsWith(".") ||
          domainPart.includes("..") ||
          domainPart.startsWith(".") ||
          domainPart.endsWith(".") ||
          domainParts.length > 2
        ) {
          errorSetter(
            "Email is invalid. Local part or domain should not contain consecutive periods, start, or end with a period, and domain should not contain multiple top-level domains."
          );
        } else {
          errorSetter(null); // Clear any previous errors
        }
      }
    }

    setter(value); // Update state with input value
    setDataChanged(true); // Mark data as changed
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0 && acceptedFiles[0].type.startsWith("image/")) {
      const file = acceptedFiles[0];
      const reader = new FileReader();

      reader.onload = () => {
        setImage(reader.result);
        setDataChanged(true);
      };

      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid image file.");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/*",
  });

  const handleImageChange = (event) => {
    setImage({
      bytes: event.target.files[0],
      filename: URL.createObjectURL(event.target.files[0]),
    });
    setDataChanged(true);
  };

  const handleImagereset = () => {
    setImage("");
  };

  const handleSubmit = async () => {
    if (!isDataChanged) return;
    setIsLoading(true);
    var formData = {
      userId: user,
      accountId: account,
      customerBranding: customerBranding,
      surveyDomain: surveyDomain,
      helpDeskEmail: HelpdeskEmail,
      termAndConditionLink: termslink,
      privacyLink: privacyLink,
      primaryColorCode: primaryColor,
      secondaryColorCode: secondaryColor,
      surveyFont: primaryTypeface,
      logo: image,
    };
    let result = await putData("users/branding-details", formData);
    if (result) {
      // alert("User updated Successfully!");
      setAlerts([{ variant: "success", heading: "User updated Successfully!" }]);

      setIsLoading(false);
      navigate("/manage-customer");
    } else {
      // alert("Something went wrong!");
      setAlerts([{ variant: "danger", heading: "Something went wrong!" }]);
      setIsLoading(false);
    }
  };

  // const handleClear = () => {
  //   // setSurveyDomain("");
  //   // setHelpdeskEmail("");
  //   // setTermsLink("");
  //   // setPrivacyLink("");
  //   // setPrimaryColor("");
  //   // setSecondaryColor("");
  //   // setPrimaryTypeface("");
  //   // setImage("");
  //   fetchCustomerAdmins();
  //   setDataChanged(false);
  // };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />

        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}

        <div id="page_wrapper" className={`py-3 ${isLoading ? "blur" : ""}`}>
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-people"></i> Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-app-indicator mx-2"></i> Manage Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <li>
                <i className="bi bi-pencil-square mx-2"></i>Edit Branding
              </li>
            </ul>

            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
          <div className="steps_box mb-3 fw-600">
            <Link to="/ebasic-detail">
              <div>
                <span className="step_count">1</span>Edit Basic Details
              </div>
            </Link>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <Link to="/ebilling-detail">
              <div>
                <span className="step_count ">2</span>Edit Billing Details
              </div>
            </Link>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>

            <div>
              <span className="step_count active">3</span>Edit Branding
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Customer Branding</label>
                    <select
                      value={customerBranding}
                      name=""
                      id=""
                      className="form-control"
                      onChange={(event) => handleInputChange(event, setCustomerBranding)}
                      disabled={userRole === "U"}
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  {customerBranding === "1" && (
                    <div className="form-group mb-4">
                      <label for="">Domain for survey</label>
                      <input
                        type="text"
                        value={surveyDomain}
                        className={`form-control ${surveyDomainError ? "is-invalid" : ""}`}
                        placeholder="Enter domain"
                        onChange={(event) => handleInputChange(event, setSurveyDomain)}
                        readOnly={userRole === "U"}
                      />
                      {surveyDomainError && <div className="invalid-feedback">{surveyDomainError}</div>}
                    </div>
                  )}
                </div>

                <div className="col-lg-6"></div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="col-lg-12">
                        <div className="form-group mb-4">
                          <label for="">Upload Logo</label>
                          <div className="drop-zone">
                            {image ? (
                              <div className="image-preview-container">
                                <img src={image} alt="Uploaded" className="image-preview" />
                                {userRole === "U" ? (
                                  ""
                                ) : (
                                  <div onClick={handleImagereset} className="text-overlay  position-absolute ">
                                    <i className="bi bi-x fs-20"></i>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="dropzone">
                                <div {...getRootProps()} className="drop-zone__prompt fs-16 fw-500 text-dark">
                                  <input {...getInputProps()} onChange={handleImageChange} readOnly={userRole === "U"} />
                                  <div className="text-center mb-3">
                                    <i className="bi bi-images fs-50 text-green"></i>
                                  </div>
                                  Drop your files here or <span className="text-green">browse</span>
                                  <br />
                                  <span className="text-grey fs-13"> Maximum size: 50MB</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mb-4">
                            <label htmlFor="">Helpdesk Email ID</label>
                            {/* <input
                              type="email"
                              value={HelpdeskEmail}
                              className="form-control"
                              placeholder="Enter email-ID"
                              onChange={(event) =>
                                handleInputChange(event, setHelpdeskEmail)
                              }
                              readOnly={userRole === "U"}
                            /> */}
                            <input
                              type="email"
                              id="helpdesk-email"
                              placeholder="Enter email-Id"
                              className="form-control"
                              value={HelpdeskEmail}
                              onChange={(event) =>
                                handleInputChange(
                                  event,
                                  setHelpdeskEmail,
                                  setHelpdeskEmailError // Pass the errorSetter for Helpdesk Email
                                )
                              }
                            />
                            {HelpdeskEmailError && <span className="text-danger">{HelpdeskEmailError}</span>}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-4">
                            <label htmlFor="">Terms & Conditions Link</label>
                            <input
                              type="url"
                              value={termslink}
                              className="form-control"
                              placeholder="Enter URL"
                              readOnly={userRole === "U"}
                              onChange={(event) => handleInputChange(event, setTermsLink)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-4">
                            <label htmlFor="">Privacy Link</label>
                            <input
                              type="url"
                              value={privacyLink}
                              className="form-control"
                              placeholder="Enter URL"
                              readOnly={userRole === "U"}
                              onChange={(event) => handleInputChange(event, setPrivacyLink)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Primary Color Code</label>
                    {showPrimaryColorPicker && (
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "absolute",
                            top: "-250px",
                            zIndex: 999,
                          }}
                          ref={pickerRef}
                        >
                          <ChromePicker
                            color={primaryColor || "#FFFFFF"}
                            onChangeComplete={(color) => {
                              if (color) {
                                setPrimaryColor(color.hex);
                                setDataChanged(true);
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <input
                      type="text"
                      value={primaryColor}
                      className="form-control"
                      placeholder="Enter hexacode"
                      readOnly={userRole === "U"}
                      onFocus={() => setShowPrimaryColorPicker(true)}
                      ref={inputRef}
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Secondary Color Code</label>
                    {showSecondaryColorPicker && (
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "absolute",
                            top: "-250px",
                            zIndex: 999,
                          }}
                          ref={pickerRef}
                        >
                          <ChromePicker
                            color={secondaryColor || "#FFFFFF"}
                            onChangeComplete={(color) => {
                              if (color) {
                                setSecondaryColor(color.hex);
                                setDataChanged(true);
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                    <input
                      type="text"
                      value={secondaryColor}
                      className="form-control"
                      placeholder="Enter hexacode"
                      readOnly={userRole === "U"}
                      onFocus={() => setShowSecondaryColorPicker(true)}
                      ref={inputRef}
                      style={{ textTransform: "uppercase" }}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Primary Typeface</label>
                    <Select
                      options={primaryTypefaceList}
                      value={primaryTypefaceList.find((option) => option.value === primaryTypeface)}
                      onChange={(selectedOption) => {
                        setPrimaryTypeface(selectedOption.value);
                        setDataChanged(true);
                      }}
                      placeholder="Select Primary Typeface"
                      isSearchable
                      isDisabled={userRole === "U"}
                      menuPlacement="top"
                    />
                  </div>
                </div>
                {/* </div>  <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="">Primary Typeface</label>
                    <input
                      type="text"
                      value={primaryTypeface}
                      className="form-control"
                      placeholder="Enter typeface name"
                      readOnly={userRole === "U"}
                      onChange={(event) => handleInputChange(event, setPrimaryTypeface)}
                    />
                  </div>
                </div> */}
              </div>

              <div className="d-flex justify-content-between">
                <div className="button_group">
                  <Link to="/ebilling-detail">
                    <button type="button" className="btn btn-light text-grey me-3">
                      <i className="bi bi-chevron-left me-1"></i> Back
                    </button>
                  </Link>
                  {/* <button
                    type="button"
                    className="btn bg-danger-subtle text-danger"
                    onClick={() => handleClear()}
                  >
                    Clear Values
                  </button> */}
                </div>
                <div className="button_group">
                  <button
                    type="button"
                    className="btn btn-success px-4"
                    onClick={() => {
                      if (isDataChanged) {
                        handleSubmit();
                      } else if (userRole === "S") {
                        navigate("/manage-customer");
                      } else {
                        navigate("/dashboard");
                      }
                    }}
                  >
                    {isDataChanged ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Branding;
